export { AnimatedHeader } from './AnimatedHeader';
export { ANIMATED_HEADER_SIZE } from './AnimatedHeader.constants';
